/**
 * Cart Drawer - Motion-tyylinen toteutus + dynaamiset maksutavat
 * Käyttää cart.ajax.liquid templatea
 * LOPULLINEN KORJATTU VERSIO (Heinäkuu 2025)
 */

// Globaali formatMoney funktio
function formatMoney(cents, format) {
  if (window.Shopify && window.Shopify.formatMoney) {
    return window.Shopify.formatMoney(cents, format || window.shopSettings?.moneyFormat);
  }
  const currencyCode = window.shopSettings?.currencyCode || 'USD';
  const locale = document.documentElement.lang || 'en-US';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode
  }).format(cents / 100);
}

// Cart helper functions
window.theme = window.theme || {};
theme.cart = {
  getCart: function() {
    const url = '/cart.js?t=' + Date.now();
    return fetch(url, {
      credentials: 'same-origin',
      method: 'GET'
    }).then(response => response.json());
  },
  
  getCartProductMarkup: function() {
    const url = '/cart?view=ajax&t=' + Date.now();
    return fetch(url, {
      credentials: 'same-origin',
      method: 'GET'
    }).then(response => response.text());
  },
  
  changeItem: function(key, qty) {
    return fetch('/cart/change.js?t=' + Date.now(), {
      method: 'POST',
      body: JSON.stringify({ id: key, quantity: qty }),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    }).then(response => response.json());
  }
};

// Cart Drawer objekti
const CartDrawer = {
  drawer: null,
  isOpen: false,
  isUpdating: false,
  triggerElement: null,
  cartIconElement: null,

  init() {
    this.drawer = document.getElementById('cart-drawer');
    if (!this.drawer) return;

    this.cartIconElement = document.querySelector('.header-icon--cart');
    this.backdrop = this.drawer.querySelector('.cart-drawer-backdrop');
    this.closeBtn = this.drawer.querySelector('.cart-drawer-close');
    this.itemsContainer = document.getElementById('cart-drawer-items');
    
    if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
    if (this.backdrop) this.backdrop.addEventListener('click', () => this.close());
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) this.close();
    });
    
    this.itemsContainer.addEventListener('click', (e) => {
      const quantityBtn = e.target.closest('.drawer-quantity-adjust');
      if (quantityBtn) {
        e.preventDefault();
        const key = quantityBtn.dataset.key;
        const action = quantityBtn.dataset.action;
        const quantityInput = quantityBtn.closest('.drawer-item').querySelector('.drawer-item-quantity');
        if (!quantityInput) return;
        const currentQuantity = parseInt(quantityInput.textContent, 10);
        let newQuantity = currentQuantity;
        if (action === 'increase') {
          newQuantity = currentQuantity + 1;
        } else if (action === 'decrease') {
          newQuantity = Math.max(0, currentQuantity - 1);
        }
        this.updateItemQuantity(key, newQuantity);
      }
      
      const removeBtn = e.target.closest('.drawer-remove-btn, .drawer-remove-x');
      if (removeBtn) {
        e.preventDefault();
        const key = removeBtn.dataset.key;
        this.updateItemQuantity(key, 0);
      }
    });
  },

  open(trigger = null) {
    if (this.isOpen) return;

    if (trigger) {
      this.triggerElement = trigger;
    }

    this.drawer.style.display = 'block';
    
    requestAnimationFrame(() => {
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-is-open');
      this.isOpen = true;
      if (this.closeBtn) {
        this.closeBtn.focus();
      }
    });
    
    this.buildCart();
  },

  close() {
    if (!this.isOpen) return;

    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-is-open');
    this.isOpen = false;

    const focusTarget = this.triggerElement || this.cartIconElement;
    if (focusTarget) {
      focusTarget.focus();
    }

    this.triggerElement = null;
    
    setTimeout(() => {
      if (!this.drawer.classList.contains('is-open')) {
        this.drawer.style.display = 'none';
      }
    }, 300);
  },

  buildCart() {
    theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this)).catch(console.error);
  },

  cartMarkup(text) {
    const parser = new DOMParser();
    const html = parser.parseFromString(text, 'text/html');
    const items = html.querySelector('.drawer-items');
    
    if (!items) {
      console.error('Drawer items container not found in ajax response');
      this.itemsContainer.innerHTML = '<p class="empty-cart-message">Your cart is empty.</p>';
      const footer = this.drawer.querySelector('.cart-drawer-footer');
      if (footer) footer.style.display = 'none';
      this.updateCount(0);
      return;
    }
    
    const count = parseInt(items.dataset.count, 10) || 0;
    const subtotal = parseInt(items.dataset.cartSubtotal, 10) || 0;
    const originalTotal = parseInt(items.dataset.cartOriginalTotal, 10) || 0;
    const savings = parseInt(items.dataset.cartSavings, 10) || 0;
    const footer = this.drawer.querySelector('.cart-drawer-footer');

    if (count > 0) {
      this.itemsContainer.innerHTML = items.innerHTML;
      if (footer) footer.style.display = '';
    } else {
      this.itemsContainer.innerHTML = '<p class="empty-cart-message">Your cart is empty.</p>';
      if (footer) footer.style.display = 'none';
    }
    
    const savingsSummaryEl = this.drawer.querySelector('.cart-drawer-savings-summary');
    if (savingsSummaryEl) {
        if (savings > 0) {
            savingsSummaryEl.style.display = 'block';
            const originalTotalEl = savingsSummaryEl.querySelector('[data-original-total-price]');
            const savingsAmountEl = savingsSummaryEl.querySelector('[data-savings-amount]');
            if (originalTotalEl) originalTotalEl.textContent = formatMoney(originalTotal);
            if (savingsAmountEl) savingsAmountEl.textContent = formatMoney(savings);
        } else {
            savingsSummaryEl.style.display = 'none';
        }
    }

    const subtotalElement = this.drawer.querySelector('.cart-drawer-subtotal-price');
    if (subtotalElement) {
      subtotalElement.textContent = formatMoney(subtotal);
    }
    
    const collapsedPrice = this.drawer.querySelector('.cart-drawer-collapsed-price');
    if (collapsedPrice) {
      collapsedPrice.textContent = formatMoney(subtotal);
    }
    
    this.updateCount(count);
    this.reInit();
    this.reinitDynamicCheckout();
  },

  reinitDynamicCheckout() {
    if (window.Shopify && window.Shopify.PaymentTerms) {
      window.Shopify.PaymentTerms.init();
    }
    if (window.Shopify && window.Shopify.PaymentButton) {
      window.Shopify.PaymentButton.init();
    }
  },

  reInit() {
    // Re-initialize any needed functionality after cart rebuild
  },

  async updateItemQuantity(key, quantity) {
    if (this.isUpdating) return;
    this.isUpdating = true;
    this.drawer.classList.add('is-loading');
    
    try {
      const updatedCartState = await theme.cart.changeItem(key, quantity);
      document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: {
          cart: updatedCartState,
          source: 'cart-drawer'
        }
      }));
      this.buildCart();
    } catch (error) {
      console.error('Update quantity error:', error);
    } finally {
      this.isUpdating = false;
      this.drawer.classList.remove('is-loading');
    }
  },

  updateCount(count) {
    const countEls = document.querySelectorAll('.cart-link__bubble-num, .cart-count-bubble');
    countEls.forEach(el => {
      el.textContent = count;
      if (el.classList.contains('cart-count-bubble')) {
         el.style.display = count > 0 ? 'inline-flex' : 'none';
      }
    });
    
    const drawerCount = this.drawer.querySelector('.cart-drawer-count');
    if (drawerCount) {
      const itemText = count === 1 ? 'item' : 'items';
      drawerCount.textContent = `${count} ${itemText}`;
    }
  }
};

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  CartDrawer.init();
  
  const cartIcon = document.querySelector('.header-icon--cart');
  if (cartIcon) {
    cartIcon.addEventListener('click', function(e) {
      e.preventDefault();
      CartDrawer.open(this);
    });
  }
  
  document.addEventListener('ajaxProduct:added', function() {
    CartDrawer.open(); 
  });
  
  document.addEventListener('cart:updated', function(e) {
    if (e.detail.source === 'cart-drawer') return;
    const cart = e.detail.cart;
    if (cart && typeof cart.item_count !== 'undefined') {
      CartDrawer.updateCount(cart.item_count);
    }
  });
});

// Global function to open cart
window.openCartDrawer = (trigger) => CartDrawer.open(trigger);